import React, { useEffect, createElement } from 'react';
import { Check, X, AlertTriangle, Star, ShieldCheck, Heart, Zap, Battery, Brain, Activity } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { SalesPopup } from '../components/SalesPopup';
// Image Constants
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/7h8Ah1uUrUrmgN3qMaUGE5/ChatGPT_Image_29_ene_2026,_11_07_08.png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/pXhEf4oGXup8FJ58QXbHWd/ChatGPT_Image_29_ene_2026,_11_33_15.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/pLESxuotukLZU9FKhSyN55/ChatGPT_Image_29_ene_2026,_11_33_25.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/hQ8XMgtQo6QfmgSnYZxu1T/ChatGPT_Image_29_ene_2026,_11_33_36.png';
const BONUS_4_IMAGE = 'https://cdn.magicpatterns.com/uploads/mwiugrUmtgPdGHrCJvm8Mz/ChatGPT_Image_29_ene_2026,_11_34_15.png';
const CHECKOUT_URL = 'https://pagos.kaisen.studio/checkouts/cn/hWN8AiqKXRB3k2sBJ6hApo6U/es-ar?_r=AQABbpE6sJ9qWEsj7QWKmo70VRor1UlUm2k3lthQRpsjn9A&cart_link_id=hFHkHqTX&preview_theme_id=143515418726';
export function SalesPage() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1610463753484952');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1610463753484952&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually pixel scripts stay
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-14">
      <SalesPopup data-id="element-15" />

      {/* Top Bar */}
      <div className="bg-pink-600 text-white text-center py-2 px-4 text-sm font-bold tracking-wider" data-id="element-16">
        🔥 OFERTA ESPECIAL DISPONIBLE SOLO POR HOY
      </div>

      {/* HERO SECTION */}
      <header className="max-w-4xl mx-auto px-4 pt-8 pb-12 text-center" data-id="element-17">
        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-4 uppercase tracking-tight" data-id="element-18">
          <span className="text-pink-600" data-id="element-19">Desbloqueo</span> Hormonal
        </h1>

        <div className="max-w-md mx-auto mb-6 shadow-2xl rounded-xl overflow-hidden transform hover:scale-105 transition-transform duration-300" data-id="element-20">
          <a href={CHECKOUT_URL} data-id="element-21">
            <img src={MAIN_IMAGE} alt="Desbloqueo Hormonal Megapack" className="w-full h-auto object-cover" data-id="element-22" />
          </a>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-23">
          El Megapack Integral para Mujeres +35
        </h2>

        <p className="text-xl md:text-2xl text-gray-600 mb-8 font-medium italic" data-id="element-24">
          "Comprendé tu cuerpo, regulá tus hormonas y volvé a sentirte en
          equilibrio"
        </p>

        <CTAButton text="¡SÍ! QUIERO MI MEGAPACK AHORA" subtext="Oferta por tiempo limitado" className="mx-auto md:w-2/3" data-id="element-25" />
      </header>

      {/* PAIN POINTS SECTION - Black background for contrast */}
      <section className="bg-gray-900 text-white py-16 px-4" data-id="element-26">
        <div className="max-w-3xl mx-auto" data-id="element-27">
          <div className="flex items-center gap-3 mb-6 justify-center" data-id="element-28">
            <AlertTriangle className="text-yellow-400 w-8 h-8" data-id="element-29" />
            <h3 className="text-2xl md:text-3xl font-bold text-center" data-id="element-30">
              Si sentís que tu cuerpo ya no responde como antes…
            </h3>
          </div>

          <p className="text-lg text-gray-300 text-center mb-10" data-id="element-31">
            No estás fallando. Estás atravesando una etapa que nadie te enseñó a
            entender.
          </p>

          <div className="bg-gray-800 p-8 rounded-xl shadow-lg border border-gray-700" data-id="element-32">
            <h4 className="text-xl font-semibold mb-6 text-pink-400" data-id="element-33">
              Tal vez te pasa que:
            </h4>
            <ul className="space-y-4" data-id="element-34">
              {['Te levantás cansada, aunque hayas dormido', 'Sentís inflamación, hinchazón o aumento de peso sin explicación', 'Tenés ansiedad, antojos o cambios de humor', 'Hacés "todo bien" y aun así no ves resultados', 'Empezaste a desconfiar de tu propio cuerpo'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-35">
                  <X className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-36" />
                  <span className="text-lg" data-id="element-37">{item}</span>
                </li>)}
            </ul>
            <p className="mt-8 text-lg font-medium italic text-center border-t border-gray-700 pt-6" data-id="element-38">
              Y en silencio te preguntás: <br data-id="element-39" />
              <span className="text-yellow-400" data-id="element-40">
                "¿Esto es normal… o algo anda mal conmigo?"
              </span>
            </p>
          </div>

          <div className="mt-10 text-center" data-id="element-41">
            <p className="text-2xl font-bold text-white" data-id="element-42">
              👉 La respuesta es clara:{' '}
              <span className="text-pink-500 underline decoration-4 decoration-pink-500/30" data-id="element-43">
                no sos vos.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-44">
        <h3 className="text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900" data-id="element-45">
          Tu cuerpo no está roto
        </h3>
        <p className="text-xl text-center text-gray-600 mb-12" data-id="element-46">
          Está pidiendo{' '}
          <span className="font-bold text-pink-600" data-id="element-47">ajustes inteligentes</span>
        </p>

        <div className="prose prose-lg mx-auto text-gray-700" data-id="element-48">
          <p className="mb-6" data-id="element-49">
            Después de los 35, las hormonas cambian la forma en que tu cuerpo
            responde a:
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8" data-id="element-50">
            {['La comida', 'El ejercicio', 'El estrés', 'El descanso', 'Las emociones'].map(item => <div key={item} className="bg-pink-50 p-4 rounded-lg text-center font-semibold text-pink-800 border border-pink-100" data-id="element-51">
                {item}
              </div>)}
          </div>
          <p className="mb-6" data-id="element-52">
            Seguir aplicando las mismas reglas de siempre solo genera más
            frustración, más cansancio y más culpa.
          </p>
          <p className="font-bold text-xl text-gray-900 mb-8" data-id="element-53">
            Lo que necesitás no es exigirte más. Es entender mejor lo que te
            está pasando.
          </p>
        </div>
      </section>

      {/* MEGAPACK INTRO */}
      <section className="bg-pink-50 py-16 px-4 border-y border-pink-100" data-id="element-54">
        <div className="max-w-4xl mx-auto text-center" data-id="element-55">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-56">
            Por eso creamos este{' '}
            <span className="text-pink-600" data-id="element-57">MEGAPACK INTEGRAL</span>
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto mb-10" data-id="element-58">
            Un sistema completo de 5 tomos diseñados para acompañarte desde la
            comprensión hasta la regulación, sin extremos, sin castigos y sin
            dietas imposibles.
          </p>

          <div className="bg-white p-6 rounded-xl shadow-md inline-block mb-8" data-id="element-59">
            <p className="text-lg font-medium text-gray-800" data-id="element-60">
              Este no es un producto aislado. Es un camino guiado para volver a
              sentirte en control de tu cuerpo.
            </p>
          </div>
        </div>
      </section>

      {/* TOMOS BREAKDOWN */}
      <section className="py-16 px-4 max-w-5xl mx-auto space-y-16" data-id="element-61">
        <div className="text-center mb-12" data-id="element-62">
          <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-63">
            🌿 ¿Qué incluye el MEGAPACK?
          </span>
        </div>

        {/* Tomo 1 */}
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-64">
          <div className="w-full md:w-1/2" data-id="element-65">
            <a href={CHECKOUT_URL} data-id="element-66">
              <img src={MAIN_IMAGE} alt="Tomo 1" className="rounded-xl shadow-2xl w-full transform hover:scale-105 transition-all" data-id="element-67" />
            </a>
          </div>
          <div className="w-full md:w-1/2" data-id="element-68">
            <h3 className="text-2xl font-bold text-blue-600 mb-2" data-id="element-69">
              📘 TOMO 1 – DESBLOQUEO HORMONAL
            </h3>
            <p className="text-gray-600 mb-4 font-semibold" data-id="element-70">
              La guía principal.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-71">
              Entendés qué está pasando con tus hormonas y cómo ajustar
              alimentación, ayuno, movimiento y hábitos diarios para que tu
              cuerpo deje de resistirse y empiece a responder.
            </p>
            <ul className="space-y-2" data-id="element-72">
              <li className="flex items-center gap-2" data-id="element-73">
                <Check className="text-green-500 w-5 h-5" data-id="element-74" /> Explicación clara y
                humana
              </li>
              <li className="flex items-center gap-2" data-id="element-75">
                <Check className="text-green-500 w-5 h-5" data-id="element-76" /> Estrategias
                aplicables desde el primer día
              </li>
              <li className="flex items-center gap-2" data-id="element-77">
                <Check className="text-green-500 w-5 h-5" data-id="element-78" /> Plan hormonal de 7
                días + lista de compras
              </li>
            </ul>
          </div>
        </div>

        {/* Tomo 2 */}
        <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-79">
          <div className="w-full md:w-1/2" data-id="element-80">
            <a href={CHECKOUT_URL} data-id="element-81">
              <img src={BONUS_1_IMAGE} alt="Tomo 2" className="rounded-xl shadow-2xl w-full h-auto object-contain transform hover:scale-105 transition-all" data-id="element-82" />
            </a>
          </div>
          <div className="w-full md:w-1/2" data-id="element-83">
            <h3 className="text-2xl font-bold text-red-500 mb-2" data-id="element-84">
              📕 TOMO 2 – COMER EN PAZ
            </h3>
            <p className="text-gray-600 mb-4 font-semibold" data-id="element-85">
              Para soltar la culpa y volver a confiar en tu alimentación.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-86">
              Aprendés a diferenciar hambre emocional, hormonal y real, y a
              comer desde la regulación, no desde la pelea interna.
            </p>
            <ul className="space-y-2" data-id="element-87">
              <li className="flex items-center gap-2" data-id="element-88">
                <Check className="text-green-500 w-5 h-5" data-id="element-89" /> Menos ansiedad con
                la comida
              </li>
              <li className="flex items-center gap-2" data-id="element-90">
                <Check className="text-green-500 w-5 h-5" data-id="element-91" /> Más calma digestiva
              </li>
              <li className="flex items-center gap-2" data-id="element-92">
                <Check className="text-green-500 w-5 h-5" data-id="element-93" /> Mejor relación con
                tu cuerpo
              </li>
            </ul>
          </div>
        </div>

        {/* Tomo 3 */}
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-94">
          <div className="w-full md:w-1/2" data-id="element-95">
            <a href={CHECKOUT_URL} data-id="element-96">
              <img src={BONUS_2_IMAGE} alt="Tomo 3" className="rounded-xl shadow-2xl w-full h-auto object-contain transform hover:scale-105 transition-all" data-id="element-97" />
            </a>
          </div>
          <div className="w-full md:w-1/2" data-id="element-98">
            <h3 className="text-2xl font-bold text-orange-500 mb-2" data-id="element-99">
              📙 TOMO 3 – MOVIMIENTO QUE REGULA
            </h3>
            <p className="text-gray-600 mb-4 font-semibold" data-id="element-100">
              Cómo moverte sin agotarte ni sabotear tus hormonas.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-101">
              Dejás atrás el "si no duele, no sirve" y aprendés a elegir
              movimiento que acompañe tu energía real.
            </p>
            <ul className="space-y-2" data-id="element-102">
              <li className="flex items-center gap-2" data-id="element-103">
                <Check className="text-green-500 w-5 h-5" data-id="element-104" /> Movimiento femenino
                y consciente
              </li>
              <li className="flex items-center gap-2" data-id="element-105">
                <Check className="text-green-500 w-5 h-5" data-id="element-106" /> Menos inflamación y
                cansancio
              </li>
              <li className="flex items-center gap-2" data-id="element-107">
                <Check className="text-green-500 w-5 h-5" data-id="element-108" /> Más constancia sin
                exigencia
              </li>
            </ul>
          </div>
        </div>

        {/* Tomo 4 */}
        <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-109">
          <div className="w-full md:w-1/2" data-id="element-110">
            <a href={CHECKOUT_URL} data-id="element-111">
              <img src={BONUS_3_IMAGE} alt="Tomo 4" className="rounded-xl shadow-2xl w-full h-auto object-contain transform hover:scale-105 transition-all" data-id="element-112" />
            </a>
          </div>
          <div className="w-full md:w-1/2" data-id="element-113">
            <h3 className="text-2xl font-bold text-blue-600 mb-2" data-id="element-114">
              📘 TOMO 4 – MENOPAUSIA EN CALMA
            </h3>
            <p className="text-gray-600 mb-4 font-semibold" data-id="element-115">
              Comprender esta etapa para dejar de temerle.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-116">
              Una guía clara y contenedora para transitar perimenopausia y
              menopausia sin miedo, sin dramatismo y con ajustes inteligentes.
            </p>
            <ul className="space-y-2" data-id="element-117">
              <li className="flex items-center gap-2" data-id="element-118">
                <Check className="text-green-500 w-5 h-5" data-id="element-119" /> Entender los
                cambios hormonales
              </li>
              <li className="flex items-center gap-2" data-id="element-120">
                <Check className="text-green-500 w-5 h-5" data-id="element-121" /> Normalizar síntomas
                sin resignarte
              </li>
              <li className="flex items-center gap-2" data-id="element-122">
                <Check className="text-green-500 w-5 h-5" data-id="element-123" /> Reconectar con tu
                cuerpo en transición
              </li>
            </ul>
          </div>
        </div>

        {/* Tomo 5 */}
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-124">
          <div className="w-full md:w-1/2" data-id="element-125">
            <a href={CHECKOUT_URL} data-id="element-126">
              <img src={BONUS_4_IMAGE} alt="Tomo 5" className="rounded-xl shadow-2xl w-full h-auto object-contain transform hover:scale-105 transition-all" data-id="element-127" />
            </a>
          </div>
          <div className="w-full md:w-1/2" data-id="element-128">
            <h3 className="text-2xl font-bold text-red-500 mb-2" data-id="element-129">
              📕 TOMO 5 – CALMAR PARA REGULAR
            </h3>
            <p className="text-gray-600 mb-4 font-semibold" data-id="element-130">
              Manejo consciente de la ansiedad.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-131">
              Aprendés a regular tu sistema nervioso para bajar la ansiedad que
              impacta en el peso, la energía, el sueño y la alimentación.
            </p>
            <ul className="space-y-2" data-id="element-132">
              <li className="flex items-center gap-2" data-id="element-133">
                <Check className="text-green-500 w-5 h-5" data-id="element-134" /> Herramientas
                corporales simples
              </li>
              <li className="flex items-center gap-2" data-id="element-135">
                <Check className="text-green-500 w-5 h-5" data-id="element-136" /> Calma real, no
                forzada
              </li>
              <li className="flex items-center gap-2" data-id="element-137">
                <Check className="text-green-500 w-5 h-5" data-id="element-138" /> Más claridad mental
                y bienestar
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* MID PAGE CTA */}
      <div className="bg-gray-100 py-12 px-4 text-center" data-id="element-139">
        <CTAButton text="OBTENER MI MEGAPACK HOY" subtext="Acceso inmediato a los 5 tomos" className="mx-auto md:w-1/2" data-id="element-140" />
      </div>

      {/* TRANSFORMATION */}
      <section className="py-16 px-4 bg-white" data-id="element-141">
        <div className="max-w-4xl mx-auto" data-id="element-142">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-143">
            ✨ ¿Qué cambia cuando empezás a trabajar con tu cuerpo y no contra
            él?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-144">
            {[{
            icon: Battery,
            text: 'Más energía real'
          }, {
            icon: Activity,
            text: 'Menos inflamación'
          }, {
            icon: Heart,
            text: 'Mejor descanso'
          }, {
            icon: Brain,
            text: 'Menos ansiedad y culpa'
          }, {
            icon: Star,
            text: 'Más conexión con su cuerpo'
          }, {
            icon: ShieldCheck,
            text: 'Sensación de equilibrio y control'
          }].map((benefit, idx) => <div key={idx} className="flex items-center gap-4 p-4 bg-pink-50 rounded-lg border border-pink-100" data-id="element-145">
                <benefit.icon className="w-8 h-8 text-pink-600" data-id="element-146" />
                <span className="text-lg font-semibold text-gray-800" data-id="element-147">
                  {benefit.text}
                </span>
              </div>)}
          </div>

          <p className="text-xl text-center text-gray-700 italic" data-id="element-148">
            A veces en días. A veces en semanas. Pero siempre desde un lugar
            sostenible y amable.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-149">
        <div className="max-w-6xl mx-auto" data-id="element-150">
          <h3 className="text-3xl font-bold text-center mb-12" data-id="element-151">
            Lo que dicen mujeres como vos
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-152">
            {[{
            text: 'Recuperé mi energía en semanas. Pensé que era la edad, pero era falta de información. Este pack me abrió los ojos.',
            name: 'Claudia',
            age: '42',
            location: 'Córdoba'
          }, {
            text: 'Por fin entiendo qué comer sin sentir culpa. Los antojos desaparecieron y me siento mucho más liviana.',
            name: 'Marcela',
            age: '38',
            location: 'Buenos Aires'
          }, {
            text: 'La guía de menopausia me dio la paz que necesitaba. Gracias por tanto, me sentía muy sola en esto.',
            name: 'Patricia',
            age: '48',
            location: 'Rosario'
          }, {
            text: 'Ejercicios que no me matan y me hacen sentir bien. Un cambio total de mentalidad que necesitaba.',
            name: 'Laura',
            age: '45',
            location: 'Mendoza'
          }, {
            text: 'La ansiedad bajó muchísimo. Me siento yo de nuevo, más tranquila y en control.',
            name: 'Silvana',
            age: '39',
            location: 'Mar del Plata'
          }].map((testimonial, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-153">
                <div className="flex text-yellow-400 mb-4" data-id="element-154">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-155" />)}
                </div>
                <p className="text-gray-700 mb-6 italic" data-id="element-156">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-157">
                  <div className="w-10 h-10 bg-pink-200 rounded-full flex items-center justify-center text-pink-700 font-bold" data-id="element-158">
                    {testimonial.name[0]}
                  </div>
                  <div data-id="element-159">
                    <p className="font-bold text-gray-900" data-id="element-160">
                      {testimonial.name}, {testimonial.age}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-161">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* TARGET AUDIENCE */}
      <section className="py-16 px-4 max-w-4xl mx-auto" data-id="element-162">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-163">
          <div className="bg-green-50 p-8 rounded-xl border border-green-100" data-id="element-164">
            <h4 className="text-xl font-bold text-green-800 mb-6" data-id="element-165">
              Este megapack es para vos si…
            </h4>
            <ul className="space-y-3" data-id="element-166">
              {['Tenés más de 35 años', 'Sentís que tu cuerpo cambió', 'Estás cansada de probar soluciones que no funcionan', 'Querés sentirte bien sin castigarte', 'Buscás comprensión, no exigencia'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-167">
                  <Check className="text-green-600 w-5 h-5 mt-1" data-id="element-168" />
                  <span className="text-gray-800" data-id="element-169">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50 p-8 rounded-xl border border-red-100" data-id="element-170">
            <h4 className="text-xl font-bold text-red-800 mb-6" data-id="element-171">
              ❌ No es para vos si...
            </h4>
            <p className="text-gray-800 font-medium" data-id="element-172">
              Buscás atajos mágicos o soluciones extremas. Esto es un proceso de
              reconexión y salud real.
            </p>
          </div>
        </div>
      </section>

      {/* EMOTIONAL MESSAGE */}
      <section className="py-12 px-4 text-center max-w-3xl mx-auto" data-id="element-173">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-174">
          Un mensaje importante antes de terminar
        </h3>
        <p className="text-xl text-gray-700 mb-4" data-id="element-175">
          Tu cuerpo no te está traicionando. No está fallando. No está roto.
        </p>
        <p className="text-2xl font-bold text-pink-600 mb-6" data-id="element-176">
          👉 Te está hablando.
        </p>
        <p className="text-lg text-gray-600" data-id="element-177">
          Este megapack es la herramienta para empezar a escucharlo, entenderlo
          y acompañarlo como necesita hoy.
        </p>
      </section>

      {/* BONUSES & PRICING SECTION */}
      <section className="bg-gray-900 text-white py-16 px-4" data-id="element-178">
        <div className="max-w-5xl mx-auto" data-id="element-179">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-4" data-id="element-180">
            🌿 DESBLOQUEO HORMONAL
          </h2>
          <h3 className="text-xl md:text-2xl text-center text-pink-400 mb-12 uppercase tracking-widest" data-id="element-181">
            Megapack Completo
          </h3>

          <p className="text-center text-gray-300 text-lg mb-12 max-w-2xl mx-auto" data-id="element-182">
            Porque tu cuerpo no necesita más control. Necesita comprensión,
            regulación y cuidado.
          </p>

          {/* BONUS GRID */}
          <div className="mb-12" data-id="element-183">
            <h4 className="text-center text-2xl font-bold text-yellow-400 mb-8" data-id="element-184">
              🎁 BONOS INCLUIDOS GRATIS POR HOY
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-185">
              {[{
              img: BONUS_1_IMAGE,
              title: 'Tomo 2: Comer en Paz'
            }, {
              img: BONUS_2_IMAGE,
              title: 'Tomo 3: Movimiento'
            }, {
              img: BONUS_3_IMAGE,
              title: 'Tomo 4: Menopausia'
            }, {
              img: BONUS_4_IMAGE,
              title: 'Tomo 5: Calmar'
            }].map((bonus, idx) => <div key={idx} className="relative group" data-id="element-186">
                  <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded shadow z-10" data-id="element-187">
                    GRATIS
                  </div>
                  <a href={CHECKOUT_URL} data-id="element-188">
                    <img src={bonus.img} alt={bonus.title} className="w-full h-auto object-contain rounded-lg border-2 border-gray-700 group-hover:border-pink-500 transition-colors" data-id="element-189" />
                  </a>
                  <p className="text-center text-sm mt-2 text-gray-400" data-id="element-190">
                    {bonus.title}
                  </p>
                </div>)}
            </div>
          </div>

          {/* PRICING CARD */}
          <div className="bg-white text-gray-900 rounded-2xl p-8 md:p-12 max-w-3xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-191">
            <div className="absolute top-0 right-0 bg-yellow-400 text-yellow-900 font-bold px-8 py-2 transform rotate-45 translate-x-8 translate-y-4 shadow-sm" data-id="element-192">
              60% OFF
            </div>

            <div className="text-center space-y-6" data-id="element-193">
              <div className="space-y-2" data-id="element-194">
                <p className="text-gray-500 text-xl line-through" data-id="element-195">
                  Precio regular: ARS $49.990
                </p>
                <p className="text-5xl md:text-7xl font-extrabold text-gray-900" data-id="element-196">
                  ARS $19,990
                </p>
                <p className="text-red-600 font-bold text-lg animate-pulse" data-id="element-197">
                  🔥 HOY SOLO
                </p>
              </div>

              <div className="space-y-4 pt-4" data-id="element-198">
                <div className="flex flex-col gap-3 items-center justify-center text-gray-700" data-id="element-199">
                  <div className="flex items-center gap-2" data-id="element-200">
                    <Check className="text-green-500 w-5 h-5" data-id="element-201" />{' '}
                    <span data-id="element-202">Acceso inmediato a los 5 tomos</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-203">
                    <Check className="text-green-500 w-5 h-5" data-id="element-204" />{' '}
                    <span data-id="element-205">Bonos exclusivos incluidos</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-206">
                    <Check className="text-green-500 w-5 h-5" data-id="element-207" />{' '}
                    <span data-id="element-208">Compra 100% segura</span>
                  </div>
                </div>
              </div>

              <div className="pt-8" data-id="element-209">
                <CTAButton text="¡EMPEZAR MI TRANSFORMACIÓN!" subtext="Descarga inmediata al completar tu compra" fullWidth className="text-xl md:text-3xl py-6" data-id="element-210" />
              </div>

              <div className="flex justify-center gap-4 pt-4 opacity-50" data-id="element-211">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-6 object-contain" data-id="element-212" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png" alt="Mastercard" className="h-6 object-contain" data-id="element-213" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/MasterCard_Logo.svg/2560px-MasterCard_Logo.svg.png" alt="Amex" className="h-6 object-contain" data-id="element-214" />
              </div>
            </div>
          </div>

          <div className="text-center mt-12 space-y-4" data-id="element-215">
            <p className="text-xl font-medium" data-id="element-216">
              👉 Empezá hoy 👉 Hacé ajustes inteligentes 👉 Volvé a sentirte en
              equilibrio
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-500 py-8 text-center text-sm border-t border-gray-800" data-id="element-217">
        <p data-id="element-218">© 2026 Desbloqueo Hormonal. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-219">
          Este producto no sustituye el consejo médico profesional.
        </p>
      </footer>
    </div>;
}